import { z } from 'zod'

export const schema = z.object({
  logged: z.boolean(),
  erck: z.string(),
  sfRemember: z.string().optional().nullable(),
  userData: z
    .object({
      fullName: z.string(),
      emailAddress: z.string(),
      picture: z.string(),
      id: z.string(),
      userType: z.enum(['TRAVELER', 'OWNER', 'EMPLOYEE']),
    })
    .nullable(),
  travelerMenuOptions: z
    .object({
      unreadMessages: z.number().int(),
      hasBookings: z.boolean(),
      cottageBookmarks: z.array(
        z.object({
          cottageId: z.string(),
        }),
      ),
    })
    .nullable(),
  ownerMenuOptions: z
    .object({
      websiteOptionType: z
        .enum(['configuration', 'presentation'])
        .optional()
        .nullable(),
      unreadMessages: z.number().int(),
      unreadBookings: z.number().int(),
    })
    .nullable(),
})

export type schemaType = z.infer<typeof schema>
